module.exports = __webpack_public_path__ + "img/much_logo.73756150.svg";